import { Component, OnDestroy, OnInit } from '@angular/core';
import { InatividadeService } from '@gestor-web/@core/auth/service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const RAIO_ANEL = 16;
const CIRCUNFERENCIA_ANEL = 2 * Math.PI * RAIO_ANEL;

/**
 * Aviso flutuante de sessão prestes a expirar por inatividade.
 *
 * Um anel que esvazia até o logout, sem números e sem botão: qualquer interação do usuário
 * reinicia a contagem no `InatividadeService` e o aviso some. O tempo restante vai no
 * `aria-label`, já que o anel não o mostra.
 */
@Component({
  selector: 'bl-aviso-inatividade',
  templateUrl: './aviso-inatividade.component.html',
  styleUrls: ['./aviso-inatividade.component.scss'],
  standalone: false,
})
export class AvisoInatividadeComponent implements OnInit, OnDestroy {
  readonly raio = RAIO_ANEL;
  readonly circunferencia = CIRCUNFERENCIA_ANEL;

  visivel = false;
  dashoffset = 0;
  rotulo: string;

  private ngDestroyed$ = new Subject<void>();

  constructor(private inatividadeService: InatividadeService) {}

  ngOnInit(): void {
    this.inatividadeService.aviso$.pipe(takeUntil(this.ngDestroyed$)).subscribe(restante => this.atualizar(restante));
  }

  ngOnDestroy(): void {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }

  private atualizar(restante: number | null): void {
    this.visivel = restante !== null;
    if (!this.visivel) {
      return;
    }
    const fracaoRestante = restante / this.inatividadeService.duracaoAvisoMs;
    this.dashoffset = CIRCUNFERENCIA_ANEL * (1 - fracaoRestante);
    const minutos = Math.ceil(restante / 60000);
    this.rotulo = `Sua sessão será encerrada por inatividade em ${minutos} ${minutos === 1 ? 'minuto' : 'minutos'}`;
  }
}
